import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRequestApprovalById = async (id) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/request-approval/${id}` });

  return data;
};

export default getRequestApprovalById;
